module.exports = __webpack_public_path__ + "img/vender.044f6696.png";